import { BodyDefaultTypography } from '@npco/zeller-design-system'
import styled from 'styled-components'

export const StyledBoldText = styled.span`
  ${BodyDefaultTypography}
  font-weight: 500;
`
